import { render, staticRenderFns } from "./ResourceEmailText.vue?vue&type=template&id=5ac04c66&"
import script from "./ResourceEmailText.vue?vue&type=script&lang=ts&"
export * from "./ResourceEmailText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports